import { Routes } from '@angular/router';
import { authGuard } from '../guard/auth.guard';

export const incubatorRoutes: Routes = [
    {
        path: 'incubator/list',
        loadComponent: () =>
            import('../incubator/incubator-list/incubator-list.component').then((m) => m.IncubatorListComponent),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/curriculum-list',
        loadComponent: () =>
            import('../incubator/incubator-list/incubator-list.component').then((m) => m.IncubatorListComponent),
        data: { variant: 'curriculum-list' },
        canActivate: [authGuard]
    },
    {
        path: 'incubator/shortlisting-list',
        loadComponent: () =>
            import('../incubator/incubator-list/incubator-list.component').then((m) => m.IncubatorListComponent),
        data: { variant: 'shortlisting-list' },
        canActivate: [authGuard]
    },
    {
        path: 'incubator/challenge-fund-list',
        loadComponent: () =>
            import('../incubator/incubator-list/incubator-list.component').then((m) => m.IncubatorListComponent),
        data: { variant: 'challenge-fund-list' },
        canActivate: [authGuard]
    },
    {
        path: 'incubator/shortlisting',
        loadComponent: () =>
            import('../incubator/incubator-shortlisting/incubator-shortlisting.component').then(
                (m) => m.IncubatorShortlistingComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/onboarding',
        loadComponent: () =>
            import('../incubator/incubator-onboarding/incubator-onboarding.component').then(
                (m) => m.IncubatorOnboardingComponent
            ),
        data: { variant: 'onboarding' },
        canActivate: [authGuard]
    },
    {
        path: 'incubator/profile-details',
        loadComponent: () =>
            import('../incubator/incubator-onboarding/incubator-onboarding.component').then(
                (m) => m.IncubatorOnboardingComponent
            ),
        data: { variant: 'profile-details' },
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/design',
        loadComponent: () =>
            import('../challenge-fund/challenge-fund-design/challenge-fund-design.component').then(
                (m) => m.ChallengeFundDesignComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/performance-evaluation.component').then(
                (m) => m.PerformanceEvaluationComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/challenge-fund-evaluation',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/challenge-fund-evaluation/challenge-fund-evaluation.component').then(
                (m) => m.ChallengeFundEvaluationComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/enterprise-ranking',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/enterprise-ranking/enterprise-ranking.component').then(
                (m) => m.EnterpriseRankingComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/fund-tracking',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/fund-tracking/fund-tracking.component').then(
                (m) => m.FundTrackingComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/challenge-fund-evaluation/add-evaluation',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/challenge-fund-evaluation/add-evaluation/add-evaluation.component').then(
                (m) => m.AddEvaluationComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/performance-evaluation',
        loadComponent: () =>
            import('../incubator/curriculum-design/performance-evaluation/performance-evaluation.component').then(
                (m) => m.PerformanceEvaluationComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/fund-tracking/add-fund-details',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/fund-tracking/add-fund-details/add-fund-details.component').then(
                (m) => m.AddFundDetailsComponent
            ),
        data: { variant: 'add-fund' },
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/design/add-fund',
        loadComponent: () =>
            import('../challenge-fund/challenge-fund-design/add-fund/add-fund.component').then(
                (m) => m.AddFundComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/curriculum-design',
        loadComponent: () =>
            import('../incubator/curriculum-design/curriculum-design.component').then(
                (m) => m.CurriculumDesignComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/performance-evaluation',
        loadComponent: () =>
            import('../incubator/curriculum-design/performance-evaluation/performance-evaluation.component').then(
                (m) => m.PerformanceEvaluationComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'incubator/curriculum-design/view-module-details/:incubatorId/:moduleId',
        loadComponent: () =>
            import('../incubator/curriculum-design/view-module-details/view-module-details.component').then(
                (m) => m.ViewModuleDetailsComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/challenge-fund-round-summary',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/challenge-fund-round-summary/challenge-fund-round-summary.component').then(
                (m) => m.ChallengeFundRoundSummaryComponent
            ),
        canActivate: [authGuard]
    },
    {
        path: 'challenge-fund/performance-evaluation/challenge-fund-round-summary/challenge-fund-round-details',
        loadComponent: () =>
            import('../challenge-fund/performance-evaluation/challenge-fund-round-summary/challenge-fund-round-details/challenge-fund-round-details.component').then(
                (m) => m.ChallengeFundRoundDetailsComponent
            ),
        canActivate: [authGuard]
    }
];

export const incubatorMobileRoutes: Routes = [
    {
        path: 'mobile/incubator/register-incubator',
        loadComponent: () =>
            import('../mobile/pages/incubator/register-incubator/register-incubator.component').then(
                (m) => m.RegisterIncubatorComponent
            ),
        canActivate: [authGuard]
    }
];
